// Module
var code = `<div appHeaderBar><header-bar-title>Properties</header-bar-title></div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true" [pmcId]=properties[0]?.hoa.pmc.couponId>
    <app-property *ngFor="let property of properties; index as currentIndex"
                  [property]="property"
                  [propertiesSize]="properties.length"
                  [currentIndex]="currentIndex"
                  class="HOA-container--multigap">
    </app-property>
    <div class="HOA-propertylanding__addProperty-marginTop u-textCenter" *ngIf="doneLoading">
        <button type="button" class="Button Button--outline" tid="addProperty" (click)="addProperty()">
            Add Property
        </button>
    </div>
</app-page-content>`;
// Exports
module.exports = code;